import { Icon } from "@iconify/react";

function DiscussionistButton({ discussionist, selected, onClick }) {
  const activeStyle = "rounded-full text-black px-2";
  const inactiveStyle = "text-[#9f9f9f] px-2";

  return (
    <button
      className={`py-2 font-bold text-left w-full md:w-64 ${
        selected ? activeStyle : inactiveStyle
      }`}
      style={{
        backgroundColor: selected ? "#eee" : "",
      }}
      onClick={() => onClick(() => onClick())}
    >
      <div className="flex flex-row gap-2 items-center">
        {!selected ? null : (
          <div className="bg-black rounded-full p-[8px]">
            <Icon icon="mingcute:check-fill" fontSize={"16px"} color="white" />
          </div>
        )}
        <div className="text-ellipsis whitespace-nowrap overflow-hidden">
          {discussionist}
        </div>
      </div>
    </button>
  );
}

export default DiscussionistButton;
